import React, { useEffect, useRef, useState } from 'react';

export default function FadeIn({ children, className = '', threshold = 0.1, delay = 0, rootRef = null }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const root = rootRef ? rootRef.current : null;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (delay) {
            setTimeout(() => setVisible(true), delay);
          } else {
            setVisible(true);
          }
          observer.unobserve(el);
        }
      },
      { threshold, root }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, delay, rootRef]);

  return (
    <div
      ref={ref}
      className={`fade-in ${visible ? 'visible' : ''} ${className}`}
    >
      {children}
    </div>
  );
}
